import * as React from 'react'
import { Button, Form, Pagination, PaginationProps, Segment, Table } from 'semantic-ui-react'
import { adminService } from '../../../../../services'
import { toast } from 'react-toastify'
import { common } from '../../../../../utils/common'

type HistoryRollRequestState = {
  data: IRollRequestTableInfo,
  totalPage: number,
  pageData?: IPageable<IRollRequest>,
  isLoading: boolean
}
const renderHeader = () => {
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>ID</Table.HeaderCell>
        <Table.HeaderCell>SteamID</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell>Bank</Table.HeaderCell>
        <Table.HeaderCell>Total Value</Table.HeaderCell>
        <Table.HeaderCell>Total Vnd</Table.HeaderCell>
        <Table.HeaderCell>Created date</Table.HeaderCell>
        <Table.HeaderCell>Email</Table.HeaderCell>
        <Table.HeaderCell>Items</Table.HeaderCell>
      </Table.Row>
    </Table.Header>)
}

const renderBody = (data?: IPageable<IRollRequest>) => {
  if (!data) {
    return (<Table.Row>No Data</Table.Row>)
  }
  return data.content.map(rollRequest => (
    <Table.Row>
      <Table.Cell>{rollRequest.id}</Table.Cell>
      <Table.Cell>{rollRequest.steamId}</Table.Cell>
      <Table.Cell>{rollRequest.status}</Table.Cell>
      <Table.Cell>{rollRequest.bank}</Table.Cell>
      <Table.Cell>{rollRequest.totalValue}</Table.Cell>
      <Table.Cell>{rollRequest.totalVnd ? rollRequest.totalVnd.toLocaleString('vn') : ''}</Table.Cell>
      <Table.Cell>{common.toLocaleDateTime(rollRequest.createdAt)}</Table.Cell>
      <Table.Cell>{rollRequest.email}</Table.Cell>
      <Table.Cell>{rollRequest.itemNameList}</Table.Cell>
    </Table.Row>
  ))
}

export class HistoryRollRequest extends React.Component {
  state: HistoryRollRequestState = {
    data: {
      page: 0,
      startDate: '',
      endDate: ''
    },
    totalPage: 1,
    isLoading: false
  }

  onDataChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    const { name, value } = event.target
    const { data } = this.state
    data[name] = value
    this.setState({ data })
  }

  onClickSearch = () => {
    this.getHistoryRollRequest(this.state.data)
  }

  getHistoryRollRequest = (data: IRollRequestTableInfo) => {
    this.setState({ isLoading: true })
    adminService.getRollRequestTable(data)
      .then(dataResult => this.setState({
        pageData: dataResult,
        totalPage: dataResult.totalPages,
        isLoading: false,
      }))
      .catch(err => {
        toast.error(err.message)
        this.setState({ isLoading: false })
      })
  }

  handlePageChange = (event: React.MouseEvent<HTMLAnchorElement>, data: PaginationProps) => {
    let dataRequest = this.state.data
    if (!data.activePage || data.activePage <= 0) {
      dataRequest.page = 0
    } else {
      dataRequest.page = Number(data.activePage) - 1
    }
    this.getHistoryRollRequest(dataRequest)
  }

  render() {
    const { data, totalPage, pageData, isLoading } = this.state
    return (
      <Segment loading={isLoading}>
        <Form>
          <Form.Group inline={true}>
            <Form.Field
              control={'input'}
              required={true}
              label="From Date"
              name="startDate"
              onChange={this.onDataChange}
              type="date"
            />
            <Form.Field
              control={'input'}
              required={true}
              label="To Date"
              name="endDate"
              onChange={this.onDataChange}
              type="date"
            />
          </Form.Group>
          <Form.Group inline={true}>
            <Form.Field
              control={'input'}
              label="Steam ID"
              name={'steamId'}
              value={data.steamId}
              onChange={this.onDataChange}
            />
            <Form.Field
              control={'input'}
              label="Roll Request ID"
              name={'id'}
              value={data.id}
              onChange={this.onDataChange}
            />
          </Form.Group>
          <Button type="submit" onClick={this.onClickSearch}>Search</Button>
        </Form>
        <Table>
          {renderHeader()}
          {renderBody(pageData)}
        </Table>
        <Pagination
          totalPages={totalPage}
          activePage={data.page + 1}
          onPageChange={this.handlePageChange}
        />

      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/containers/HistoryRollRequest.tsx